import { Table } from "reactstrap";
import InvoiceTwoHeader from "./InvoiceTwoHeader";
import InvoiceTwoDetails from "./InvoiceTwoDetails";
import InvoiceTwoBilling from "./InvoiceTwoBilling";
import InvoiceTwoContent from "./InvoiceTwoContent";
import InvoiceTwoTotal from "./InvoiceTwoTotal";
import { InvoiceButtons } from "../Common/InvoiceButtons";
import { useRef } from "react";

const InvoiceTwoContainer = () => {
  const contentRef = useRef<HTMLDivElement | null>(null);

  return (
    <>
      <div ref={contentRef}>
        <Table style={{ width: "1070px", margin: "0 auto", background: "#fff" }} borderless>
          <tbody style={{ padding: "10px" }}>
            <tr>
              <InvoiceTwoHeader />
            </tr>
            <tr>
              <InvoiceTwoDetails />
            </tr>
            <tr>
              <InvoiceTwoBilling />
            </tr>
            <tr>
              <InvoiceTwoContent />
            </tr>
            <tr>
              <InvoiceTwoTotal />
            </tr>
            <tr>
              <td>
                <span style={{ display: "block", background: "rgba(82, 82, 108, 0.3)", height: 1, width: "100%", marginBottom: 30 }} />
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
      <InvoiceButtons contentRef={contentRef} />
    </>
  );
};

export default InvoiceTwoContainer;
